import { RPCDocs } from "../../../services/rpc.js";
//#region src/modules/ServicePeriods/queries/instance-query.ts
var Sort = RPCDocs.ServicePeriods.FindServicePeriodInstances.v1.Sort;
var NOW_UPCOMING_HORIZON_MS = 10080 * 60 * 1e3;
function upcomingHorizonIso(nowIso) {
	return new Date(Date.parse(nowIso) + NOW_UPCOMING_HORIZON_MS).toISOString();
}
function scopeArgs(input) {
	const locationIds = input.locationIds?.length ? input.locationIds : input.locationId ? [input.locationId] : void 0;
	return {
		...locationIds ? { locationIds } : {},
		...input.regionIds?.length ? { regionIds: input.regionIds } : {}
	};
}
function buildCurrentWindowInstanceQueryArgs(input) {
	return {
		...scopeArgs(input),
		endsAt: { gte: input.nowIso },
		pagination: input.pagination,
		sort: ["startsAt", Sort.Asc]
	};
}
function buildNowInstanceQueryArgs(input) {
	return {
		...scopeArgs(input),
		endsAt: { gte: input.nowIso },
		pagination: input.pagination,
		sort: ["startsAt", Sort.Asc],
		startsAt: { lt: upcomingHorizonIso(input.nowIso) }
	};
}
function buildActiveInstanceQueryArgs(input) {
	return {
		...scopeArgs(input),
		endsAt: { gt: input.nowIso },
		pagination: input.pagination,
		sort: ["startsAt", Sort.Asc],
		startsAt: { lte: input.nowIso }
	};
}
function buildHistoryInstanceQueryArgs(input) {
	return {
		...scopeArgs(input),
		endsAt: { lt: input.nowIso },
		pagination: input.pagination,
		sort: ["endsAt", Sort.Desc]
	};
}
//#endregion
export { NOW_UPCOMING_HORIZON_MS, buildActiveInstanceQueryArgs, buildCurrentWindowInstanceQueryArgs, buildHistoryInstanceQueryArgs, buildNowInstanceQueryArgs, upcomingHorizonIso };

//# sourceMappingURL=instance-query.js.map